var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Secure Page")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }